import { OrthographicCamera, Vector3 } from 'three';
import Experience from './Experience.js';

export default class Camera {
    experience = new Experience();
    scene = this.experience.scene;
    renderer = this.experience.renderer;
    sizes = this.experience.sizes;
    input = this.experience.input;

    instance = new OrthographicCamera(-1, 1, 1, -1, -1, 10);
    target = new Vector3();

    constructor() {
        this.scene.add(this.instance);
        this.instance.position.z = 5;
    }

    resize() {
        this.instance.aspect = this.sizes.hero.width / this.sizes.hero.height;
        this.instance.updateProjectionMatrix();
    }

    getWidthModifier() {
        return 1 / this.sizes.width / this.sizes.height;
    }

    destroy() {
        this.scene.remove(this.instance);
        this.instance = null;
    }
}
